import { render, staticRenderFns } from "./WithPaginationAndFilters.vue?vue&type=template&id=6d36d697"
import script from "./WithPaginationAndFilters.vue?vue&type=script&lang=js"
export * from "./WithPaginationAndFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports